import { GET } from "../../helper/collaticaRestFunctions";

const asList = (value: any) => (Array.isArray(value) ? value : []);

export const getUsers = async (org_id: any) => {
  const orgId = org_id || 100000000001;
  const path = `/orgs/${orgId}/users`;
  return await GET(path)
    .then((result) => asList(result?.[1]))
    .catch((err) => {
      console.log("error on fetching users > ", err);
      return [];
    });
};
